import {Inject, Injectable} from 'ng-metadata/core';
import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import {MappingTablesCache} from '../mappingTablesCache/mappingTablesCache.service';
import {getVid, getNewspapersSearchEnabled, getDisplayFeaturedNewspapers, getDisplayNewspapersLink, getNewspaperSearchFilterByAvailability} from '../appConfig/appConfigForward';
import {SearchFieldsService} from '../search/search.fields.service';
import {SharedSessionStorage} from "../infra/sharedSessionStorage.service";
import { ConfigurationUtil } from '../nddUtils/configurationUtil.service';

@Injectable()
export class NewspapersService {
    private vid: string = getVid();
    private NEWSPAPERS_SEARCH_ENABLED: boolean = getNewspapersSearchEnabled();
    private DISPLAY_FEATURED_NEWSPAPERS: boolean = getDisplayFeaturedNewspapers();
    private DISPLAY_NEWSPAPERS_LINK: boolean = getDisplayNewspapersLink();
    private isFeaturedNewspapersTableFilled: boolean;
    private _featuredNewspapers: featuredNewspaper[] = [];
    private _cameFromSearch: boolean = false;
    private _cameFromAdvancedSearch: boolean = false;
    private _cameFromFeaturedSearch: boolean = false;
    private _regularSearchCameFrom: string = '';
    private _featuredTitle: string = '';
    private _featuredDescription: string = '';
    private _scopes: string[] = ['all','featured'];
    private _featuredScopes: string[] = ['all'];
    private _featuredScope: string = 'all';
    private _nameIssnMap: object = {};
    private _nameDescMap: object = {};
    public DEFAULT_SCOPE = 'all';
    public DEFAULT_FEATURED_SCOPE = 'all';
    private DEFAULT_DATE_NEWEST_PRIMO : string = 'date'; 
    private DEFAULT_DATE_NEWEST_PRIMO_VE : string = 'date_d';
    private DEFAULT_SORT_NEWSPAPER_BY_DATE_NEWEST_CUSTOMER_SETTING = 'default_sort_newspaper_by_date_newest';
    private _scope : string = this.DEFAULT_SCOPE;

    constructor(private mappingTablesCache: MappingTablesCache,
                private searchFieldsService: SearchFieldsService,
                private sharedSessionStorageService: SharedSessionStorage,
                private configurationUtil: ConfigurationUtil,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$stateParams') private $stateParams : angular.ui.IStateParamsService) {
        let featuredNewspapers= this.mappingTablesCache.findByProperties('Featured newspapers', {source1: this.vid});
        if (featuredNewspapers.length === 0) {
            featuredNewspapers = this.mappingTablesCache.findByProperties('Featured newspapers', {source1: 'default'});
        }
        if (featuredNewspapers.length === 0) {
            this.isFeaturedNewspapersTableFilled = false;
        }
        else {
            this.isFeaturedNewspapersTableFilled = true;
            featuredNewspapers = featuredNewspapers.sort((a,b) => {
                return (parseInt(a.source4) - parseInt(b.source4));
            });
            featuredNewspapers.forEach((row) => {
                let featuredNewspaper = {name:row.source2, description:row.source3, issn: row.target};
                this.featuredNewspapers.push(featuredNewspaper);
                this._featuredScopes.push(featuredNewspaper.name);
                this._nameIssnMap[featuredNewspaper.name] = featuredNewspaper.issn;
                this._nameDescMap[featuredNewspaper.name] = featuredNewspaper.description;

            });
            this._nameIssnMap[this.DEFAULT_FEATURED_SCOPE] = this.allFeaturedIssns;
            this._nameDescMap[this.DEFAULT_FEATURED_SCOPE] = '';
        }
    }

    public isNewspapersSearch(): boolean {
        return this.$state.current.name === STATE_NAMES.NEWSPAPERS || this.$state.current.name === STATE_NAMES.NEWSPAPERS_FULL_DISPLAY;
    }

    public get featuredNewspapers() {
        return this._featuredNewspapers;
    }

    get cameFromSearch(): boolean {
        return this._cameFromSearch;
    }

    set cameFromSearch(value: boolean) {
        this._cameFromSearch = value;
    }

    get cameFromAdvancedSearch(): boolean {
        return this._cameFromAdvancedSearch;
    }

    set cameFromAdvancedSearch(value: boolean) {
        this._cameFromAdvancedSearch = value;
    }

    get cameFromFeaturedSearch(): boolean {
        return this._cameFromFeaturedSearch;
    }

    set cameFromFeaturedSearch(value: boolean) {
        this._cameFromFeaturedSearch = value;
    }

    get featuredDescription(): string {
        return this._featuredDescription;
    }

    set featuredDescription(value: string) {
        this._featuredDescription = value;
    }

    get featuredTitle(): string {
        return this._featuredTitle;
    }

    set featuredTitle(value: string) {
        this._featuredTitle = value;
    }

    get scopes(): string[] {
        return this._scopes;
    }

    get scope(): string {
        return this._scope;
    }

    set scope(value: string) {
        this._scope = value;
        if (this._scope === 'all') {
            this.featuredScope = this.DEFAULT_FEATURED_SCOPE;
        }
    }

    get featuredScopes(): string[] {
        return this._featuredScopes;
    }

    get featuredScope(): string {
        return this._featuredScope;
    }

    set featuredScope(value: string) {
        this._featuredScope = value;
    }
    
    set regularSearchCameFrom(value: string) {
        this._regularSearchCameFrom = value;
    }
    
    get regularSearchCameFrom(): string {
        return this._regularSearchCameFrom;
    }

    get nameIssnMap(): object {
        return this._nameIssnMap;
    }

    get nameDescMap(): object {
        return this._nameDescMap;
    }


    public displayFeaturedNewspapers(): boolean {
        return this.NEWSPAPERS_SEARCH_ENABLED && this.DISPLAY_FEATURED_NEWSPAPERS && this.isFeaturedNewspapersTableFilled;
    }

    public displayNewspapersLink(): boolean {
        return !this.isNewspapersSearch() && this.isPcScope() && this.DISPLAY_NEWSPAPERS_LINK && this.NEWSPAPERS_SEARCH_ENABLED;
    }

    public isPcScope() {
        let tab = this.$stateParams['tab'];
        let scope = this.$stateParams['search_scope'];
        let pcAvailabilityTab = window.appConfig['primo-view']['pc-availability-tab-scopes-map'][tab];
        if (pcAvailabilityTab) {
            if (pcAvailabilityTab[scope]) {
                return true;
            }
        }
        return false;
    }

    public goToNewspapersFromSearch() {
        this.cameFromSearch = true;
        this.cameFromFeaturedSearch = false;
        let query = this.$stateParams['query'];
        let pcAvailability = this.$stateParams['pcAvailability'];
        if (pcAvailability === undefined) {
            pcAvailability =  getNewspaperSearchFilterByAvailability() ? "false" : "true";
        }
        let searchInFulltext = this.$stateParams['searchInFulltext'];
        let urlParams:url = {};
        urlParams.vid = this.vid;
        urlParams.offset = '0';
        if(this.$stateParams['mode'] === 'advanced'){
            //when coming from advanced search, open the newspapers with blank search
            this.searchFieldsService.mainSearch = undefined;
            this.cameFromAdvancedSearch = true;
        }
        else{
            urlParams.search_scope = this.DEFAULT_SCOPE;
            if (query) {
                urlParams.query = query;
            }
            if (pcAvailability) {
                urlParams.pcAvailability = pcAvailability;
            }
            if (searchInFulltext) {
                urlParams.searchInFulltext = searchInFulltext;
            }
        }

		        this.sharedSessionStorageService.removeItem('stickyFacets');
        this.$state.go(STATE_NAMES.NEWSPAPERS,urlParams, {reload: true});
    }
    
    public addCameFromGoToNewspapersfromRegularSearch(cameFromString:string) {
        this.regularSearchCameFrom = cameFromString;
    }
    
    public isNewspaperItem(item) {
        if ((item.context === "U" || item.context === "NP") && item.pnx && item.pnx.control &&
            item.pnx.control.sourcesystem  && Array.isArray(item.pnx.control.sourcesystem) && item.pnx.control.sourcesystem[0] === 'Newspapers'){
            return true;
        }
        return false;
    }

    private get allFeaturedIssns() {
        let issn = this.featuredNewspapers.map((featured) => {return featured.issn.replace(/;$/, '')});
        return issn.join(";");
    }

    private getDefaultSortNewspaperByDateNewest() {
        let isDefaultSortNewspaperByDateNewest =
            this.configurationUtil.getSystemConfiguration(this.DEFAULT_SORT_NEWSPAPER_BY_DATE_NEWEST_CUSTOMER_SETTING);
        return isDefaultSortNewspaperByDateNewest ? this.DEFAULT_DATE_NEWEST_PRIMO_VE : null;
    }

    private getDefaultSortNewspaperByDateNewestPrimo() {
        let isDefaultSortNewspaperByDateNewestPrimo =
            this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.INSTITUTION_PROPERTIES,
                { target: 'true', source1: this.DEFAULT_SORT_NEWSPAPER_BY_DATE_NEWEST_CUSTOMER_SETTING }).length > 0;
        return isDefaultSortNewspaperByDateNewestPrimo ? this.DEFAULT_DATE_NEWEST_PRIMO : null;
    }

    public getDefaultSortByForNewspaper() {
        return this.configurationUtil.isSuprima() ? this.getDefaultSortNewspaperByDateNewest() : this.getDefaultSortNewspaperByDateNewestPrimo();
    }

}

interface featuredNewspaper {
    name: string;
    description:string;
    issn:string;
}

interface url {
    vid?: string;
    query?: string;
    pcAvailability?: boolean;
    searchInFulltext?: boolean;
    search_scope?: string;
    offset?: string;
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/newspapers.service.ts